/**
 * The tabs that are displayed in the home screen.
 */
export const homeTabs = ['itinerary', 'summary', 'map'] as const

/**
 * The string union type of all home tabs.
 */
export type THomeTab = (typeof homeTabs)[number]

/**
 * Returns the translation key for the given home tab.
 * @param tab The home tab.
 * @returns The translation key.
 */
export function getTranslationKeyFromHomeTab(tab: THomeTab) {
    return `home.tabs.${tab}`
}

/**
 * Returns an identifier for the given home tab for use in automated testing.
 * @param tab The home tab.
 * @returns The tab identifier.
 */
export function getIdentifierFromHomeTab(tab: THomeTab) {
    return `${tab}Tab`
}